import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkles } from "lucide-react";

export default function PublicCategories() {
  const [cats, setCats] = useState([]);
  const [merchants, setMerchants] = useState([]);

  useEffect(() => {
    api.get("/catalog/categories").then((r) => setCats(r.data)).catch(() => {});
    api.get("/catalog/merchants?limit=30").then((r) => setMerchants(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <div className="text-xs uppercase tracking-[0.2em] text-emerald-700 font-semibold mb-2">Categories</div>
      <h1 className="font-display font-bold text-4xl lg:text-5xl tracking-tight text-gray-900">
        Cashback across 15 categories.
      </h1>
      <p className="text-gray-700 mt-3">Click any category to preview merchants and offers when you sign up.</p>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-10">
        {cats.map((c) => (
          <div
            key={c.slug}
            className="border border-gray-200 rounded-2xl p-5 bg-white hover:-translate-y-0.5 hover:shadow-card transition-all"
            data-testid={`pcat-${c.slug}`}
          >
            <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-700 flex items-center justify-center mb-3">
              <Sparkles className="w-5 h-5" />
            </div>
            <div className="font-display font-bold">{c.name}</div>
          </div>
        ))}
      </div>

      <h2 className="font-display font-bold text-2xl tracking-tight text-gray-900 mt-16 mb-4">
        Featured merchants
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {merchants.slice(0, 18).map((m) => (
          <div key={m.id} className="border border-gray-200 rounded-xl p-4 bg-white text-center" data-testid={`pmerch-${m.slug}`}>
            <img src={m.logo} alt={m.name} className="w-10 h-10 mx-auto mb-2 rounded-lg object-contain bg-gray-50 p-1 border border-gray-100" onError={(e) => (e.target.style.display = "none")} />
            <div className="text-sm font-semibold text-gray-800 truncate">{m.name}</div>
            <div className="text-xs text-emerald-700 mt-1">Up to {m.commission_rate}% cashback</div>
          </div>
        ))}
      </div>

      <div className="mt-16 text-center">
        <Link to="/signup" className="inline-flex items-center justify-center bg-emerald-700 hover:bg-emerald-800 text-white rounded-full px-6 py-3 text-sm font-semibold">
          Create account to unlock cashback
        </Link>
      </div>
    </div>
  );
}
